var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSegmentGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.5739 89.4228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b53154be-f3fc-4f62-a1f7-fe24ef3a9b96,.bd3fb54f-8d44-4644-ac64-7058d6d89eab{fill:#52bd94;}.bd3fb54f-8d44-4644-ac64-7058d6d89eab{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b2b0aac9-bfe7-47c1-8033-08dd00eeee5c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b53154be-f3fc-4f62-a1f7-fe24ef3a9b96",
    x: 32.8171,
    y: 28.8538,
    width: 52.2503,
    height: 9.0638,
    rx: 1.6853
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b53154be-f3fc-4f62-a1f7-fe24ef3a9b96",
    x: 0.4877,
    y: 51.5052,
    width: 52.2503,
    height: 9.0638,
    rx: 1.6853
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd3fb54f-8d44-4644-ac64-7058d6d89eab",
    d: "M6.7614,35.0584a1.6992,1.6992,0,0,0,2.0528-1.1545A35.6595,35.6595,0,0,1,50.482,9.9028,1.6712,1.6712,0,0,0,52.44,8.6873l1.4747-5.5039a1.6954,1.6954,0,0,0-1.2817-2.0879,44.7263,44.7263,0,0,0-52.56,30.39,1.6775,1.6775,0,0,0,1.1849,2.0978Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd3fb54f-8d44-4644-ac64-7058d6d89eab",
    d: "M78.8125,54.3644A1.699,1.699,0,0,0,76.76,55.5188,35.659,35.659,0,0,1,35.0919,79.52a1.6714,1.6714,0,0,0-1.9576,1.2155L31.66,86.2394a1.6954,1.6954,0,0,0,1.2817,2.0879,44.7263,44.7263,0,0,0,52.56-30.39,1.6774,1.6774,0,0,0-1.1849-2.0978Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b53154be-f3fc-4f62-a1f7-fe24ef3a9b96",
    cx: 68.613,
    cy: 13.9321,
    r: 4.9695
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b53154be-f3fc-4f62-a1f7-fe24ef3a9b96",
    cx: 16.9592,
    cy: 75.4907,
    r: 4.9695
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentGreen);
export default __webpack_public_path__ + "static/media/segmentGreen.51ea3c9c83f80ba95d21084c00463415.svg";
export { ForwardRef as ReactComponent };